<p *ngIf="descriptionPresent" [innerHTML]="description"></p>
